import { Box, Divider } from '@mui/material';
import { Control, FieldErrors, useWatch } from 'react-hook-form';
import { FC, useState } from 'react';
import { AutoLinkPatternField, DefectFormValues } from '../types';
import DefectMatchedResultsDialog from './DefectMatchedResultsDialog';
import DefectAutoLinkPatternFields from './DefectAutoLinkPatternFields';

interface DefectAutoLinkPatternItemProps {
    index: number;
    control: Control<DefectFormValues>;
    errors: FieldErrors<DefectFormValues>;
    onRemove: () => void;
}

const DefectAutoLinkPatternItem: FC<DefectAutoLinkPatternItemProps> = ({ index, control, errors, onRemove }) => {
    const [matchDialogField, setMatchDialogField] = useState<AutoLinkPatternField | null>(null);
    const basePath = `autoLinkPatterns.${index}` as const;
    const errorMessagePattern = useWatch({
        control,
        name: `autoLinkPatterns.${index}.errorMessagePattern`,
    });

    const stackTracePattern = useWatch({
        control,
        name: `autoLinkPatterns.${index}.stackTracePattern`,
    });

    const patternValue = matchDialogField === 'errorMessagePattern' ? errorMessagePattern : stackTracePattern;

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                <DefectAutoLinkPatternFields
                    basePath={basePath}
                    control={control}
                    errors={errors}
                    onViewMatch={(fieldName) => setMatchDialogField(fieldName)}
                    onRemove={onRemove}
                />
            </Box>
            <Divider flexItem sx={{ mb: 1 }} />
            <DefectMatchedResultsDialog
                open={Boolean(matchDialogField)}
                onClose={() => setMatchDialogField(null)}
                pattern={patternValue || ''}
                fieldName={matchDialogField}
            />
        </Box>
    );
};

export default DefectAutoLinkPatternItem;
